<div class="fluid grid">

  <div class="col-4 xl:col-4 sm:col-12">
    <app-companyselector [labelKey]="cliComLabel"
                         [parentCompany]="0"
                         [selectedID]="newDocument.DOCCLIENTSID"
                         (selectedCompanyID)="cliCompanySelected($event)"
                         [disabled]="true">
    </app-companyselector>
  </div>

  <div class="col-4 xl:col-4 sm:col-12">
    <app-personselector [labelKey]="cliPerLabel" [parentCompany]="newDocument.DOCCLIENTSID" [disabled]="!newDocument.DOCCLIENTSID"
                        [selectedID]="newDocument.DOCPERSONID" (selectedPersonID)="cliPersonSelected($event)"></app-personselector>
  </div>

  <div class="col-4 xl:col-4 sm:col-12" *ngIf="selectDepartmentOn">
    <app-departmentselector [labelKey]="manDepLabel" [parentCompany]="newDocument.DOCCLIENTSID"
                            [selectedID]="newDocument.DOCCLIDEPID" (selectedDepartmentID)="mainStockSelected($event)"></app-departmentselector>
  </div>

  <div class="col-4 xl:col-4 sm:col-12">
    <app-companyselector [labelKey]="pcoComLabel"
                         [parentCompany]="newDocument.DOCCLIENTSID"
                         [selectedID]="newDocument.DOCPCOCLIID"
                         (selectedCompanyID)="pcoCompanySelected($event)"></app-companyselector>
  </div>

  <div class="col-4 xl:col-4 sm:col-12">
    <app-personselector [labelKey]="pcoPerLabel"
                        [parentCompany]="newDocument.DOCPCOCLIID"
                        [disabled]="!newDocument.DOCPCOCLIID"
                        [selectedID]="newDocument.DOCPCOPERID"
                        firstAvailable="true"
                        (selectedPersonID)="pcoPersonSelected($event)"></app-personselector>
  </div>

  <div class="col-4 xl:col-4 sm:col-12" *ngIf="selectDepartmentOn">
    <app-departmentselector [labelKey]="pcoDepLabel"
                            [disabled]="true"
                            [parentCompany]="newDocument.DOCPCOCLIID"
                            [selectedID]="newDocument.DOCPCODEPID"
                            (selectedDepartmentID)="childStockSelected($event)"></app-departmentselector>
  </div>

</div>
